import { defineMessages } from 'react-intl';

/**
 * The X copy of Channels, the Composer and the Calendar (design x-connector a-d). The native apps
 * use the same ids (scripts/music24-native/i18n-keys.txt). `{posts}` and `{limit}` come from
 * `xPostsPerMonth` and the channel answer: never type the number.
 */
export const xMessages = defineMessages({
  lockedNote: {
    id: 'app.sml.promote.channels.x.lockedNote',
    defaultMessage:
      'Pro posts to X for you, up to {posts} posts a month. On your plan, save a handle and post to X yourself.',
  },
  manualNote: {
    id: 'app.sml.promote.channels.x.manualNote',
    defaultMessage: 'You post to X yourself. MUSIC24 sends you the post at its time.',
  },
  posts: {
    id: 'app.sml.promote.channels.xPosts',
    defaultMessage: '{used} of {limit} X posts this month',
  },
  postsFull: {
    id: 'app.sml.promote.channels.xPostsFull',
    defaultMessage: 'X limit reached this month. Resets on {date}.',
  },
  postsFullHint: {
    id: 'app.sml.promote.channels.xPostsFullHint',
    defaultMessage: 'New X posts stay drafts. Post them by hand, or give them a time next month.',
  },
  needsPro: {
    id: 'app.sml.promote.channels.x.needsPro',
    defaultMessage: 'Posting to X needs Pro',
  },
  needsProBody: {
    id: 'app.sml.promote.channels.x.needsProBody',
    defaultMessage: 'Your X login, posts and numbers stay. MUSIC24 does not post to X or read it until you upgrade.',
  },
  needsProMark: {
    id: 'app.sml.promote.channels.x.needsProMark',
    defaultMessage: 'Needs Pro',
  },
  chipMonthLimit: {
    id: 'app.sml.promote.composer.channels.xMonthLimit',
    defaultMessage: '· X limit reached this month',
  },
  draftHint: {
    id: 'app.sml.promote.composer.x.draftHint',
    defaultMessage: 'You can save the X post as a draft. Post it by hand, or give it a time next month.',
  },
  linkNote: {
    id: 'app.sml.promote.composer.x.linkNote',
    defaultMessage: 'A link counts as 23 characters on X.',
  },
  overLimit: {
    id: 'app.sml.promote.composer.x.overLimit',
    defaultMessage: 'This post is {count} characters over the limit of X. Shorten the caption.',
  },
  accountTitle: {
    id: 'app.sml.promote.composer.accounts.xTitle',
    defaultMessage: 'X',
  },
  calendarMonthLimit: {
    id: 'app.sml.promote.calendar.xMonthLimit',
    defaultMessage: 'X limit reached this month',
  },
});
